<template>
  <teleport to="body">
    <overlay
      key="ContentFilter"
      block-class="content-drawer-overlay"
      namespace="ContentFilter"
      direction="right"
      type="drawer"
    >
      <template #title>
        <h3
          class="content-drawer-overlay__header text-mobile-headlines-h4 text-desktop-headlines-h4"
          v-text="$string('plans.filter')"
        />
      </template>
      <template #body="overlay">
        <div :overlay="overlay" class="content-drawer">
          <div
            class="content-drawer-overlay__content"
            js-overlay="scrollElement"
          >
            <template v-for="(filterOption, key) of filterOptions" :key="key">
              <h4
                class="text-mobile-paragraph-m-bold content-drawer-overlay__filter-title"
                v-text="`${key}`"
              />

              <div
                v-for="(option, index) of filterOption"
                :key="index"
                class="content-drawer-overlay__filter"
              >
                <checkbox-input
                  :id="`${key}-${index}`"
                  :model-value="filters[key] && filters[key].includes(option)"
                  :label="`${option}${suffix}`"
                  :value="option"
                  @change="$emit('toggle-filter', { key, option })"
                />
              </div>
            </template>
          </div>
          <div class="content-drawer-overlay__filter-button">
            <btn
              class="text-mobile-paragraph-m-regular-link text-desktop-paragraph-m-regular-link"
              :label="`${$string('plans.show_results')} ${totalItemsLabel}`"
              modifiers="secondary center"
              size="large"
              @click.prevent="closeFilterOverlay"
            />
          </div>
        </div>
      </template>
    </overlay>
  </teleport>
</template>

<script>
/**
 * Vue: content-drawer (content-drawer)
 * -----------------------------------------------------------------------------
 * Drawer with filters for plan overview.
 *
 * @param {Object} filters - All filters for check active/inactive
 * @param {Object} filterOptions - All filter options to display
 * @param {String} totalItemsLabel - String that includes total items count
 *
 * @emits toggle-filter - event on checkbox, toggle filter on/off
 */

import { mapActions } from 'pinia';
import useOverlaysStore from '~stores/overlays';

import Btn from '~global/btn/btn';
import Overlay from '~global/overlay/overlay';
import CheckboxInput from '~async/utils/checkbox-input/checkbox-input';

export default {
  name: 'ContentDrawer',

  components: {
    Btn,
    Overlay,
    CheckboxInput,
  },

  props: {
    totalItemsLabel: {
      type: String,
      default: '',
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    filterOptions: {
      type: Object,
      default: () => ({
        key: ['value'],
      }),
    },
    suffix: {
      type: String,
      default: '',
    },
  },

  emits: {
    'toggle-filter': (payload) => typeof payload === 'object',
  },

  methods: {
    /**
     * Map Pinia actions.
     */
    ...mapActions(useOverlaysStore, {
      closeOverlay: 'close',
    }),

    /**
     * Closes the overlay.
     */
    closeFilterOverlay() {
      this.closeOverlay({
        component: 'content-drawer',
        ignoreDismissed: true,
        namespace: 'ContentFilter',
      });
    },
  },
};
</script>

<style lang="scss">
@import './content-drawer';
</style>
